<div >
  <breadcrumbs>
    <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="'Component Setup' | translate | async"></breadcrumb>
  </breadcrumbs>
  
</div>

<div class="page-padding">
  <div class="pannel">
    <div class="panel panel--search">
      <div class="panel__header">
        <!--Main header-->
        <span class="panel__header__title">Component Setup </span>
      </div>
    </div>


    <mat-card class="panel_search mat-card">
      <form class="header-form">
        
      <mat-form-field class="header-form-full-width">
        <mat-label>Component ID</mat-label>
        <input matInput name= "ComponentId" value="ComponentId" [(ngModel)]="ComponentId" #ComponentId_="ngModel">
      </mat-form-field>
  


      <mat-form-field class="header-form-full-width">
        <mat-label>Component Description</mat-label>
        <input matInput name= "compDesc" value="compDesc" [(ngModel)]="ComponentDescription">
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Component Type"  (selectionChange)="changeComponentType($event.value)">
          <mat-option [value]="type.Title" *ngFor="let type of _componentservice.componentTypeList">
            {{type.Title}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      
      <mat-form-field class="header-form-full-width">
        <mat-label>Component Make</mat-label>
        <input matInput name= "compMake" value="compMake" [(ngModel)]="ComponentMake">
      </mat-form-field>
      
      <mat-form-field class="header-form-full-width">
        <mat-label>Component Model</mat-label>
        <input matInput name= "compModel" value="compModel" [(ngModel)]="EquipModel">
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <mat-label>Equipment Make</mat-label>
        <input matInput name= "equipmentMake" value="equipmentMake" [(ngModel)]="EquipMake">
      </mat-form-field>
      </form>
      <!-- <a class="button" ><span class="button__text" (click)="GetComponentListForGrid()">{{'Search'}}</span></a> -->
      <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
        (click)="GetComponentListForGrid()">Search</span></a>

       <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8"style=" margin: 5px; "  > 
          <ng-container matColumnDef="ComponentId">
            <mat-header-cell  *matHeaderCellDef mat-sort-header>Component ID</mat-header-cell>
            <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.ComponentId}}</div></mat-cell>
          </ng-container>
        
          <ng-container matColumnDef="ComponentDescription">
            <mat-header-cell  *matHeaderCellDef mat-sort-header> Component Description</mat-header-cell>
            <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.ComponentDescription}}</div></mat-cell>
          </ng-container>
         
          <ng-container matColumnDef="ComponentType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Component Type</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.ComponentType}}</mat-cell>
          </ng-container>
                 
          <ng-container matColumnDef="ComponentMake">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Component Make</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.ComponentMake}}</mat-cell>
          </ng-container>
             
          <ng-container matColumnDef="EquipModel">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Equipment Model</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.EquipModel}}</mat-cell>
          </ng-container>  

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></mat-row>
        </mat-table>
        
      </mat-card>

      <mat-card class="panel_search mat-card">
        <!--sub header-->
        <div class="panel_sub_header">
          <span class="panel__header__title">Component Mandatory Details</span>
        </div>
        <form class="header-form">
      
          <mat-form-field class="header-form-full-width">
  
            <input matInput name="partNo_" [(ngModel)]="partNo" #partNo_="ngModel" placeholder="Part No">
  
          </mat-form-field>
          <mat-form-field class="header-form-full-width">
            <input matInput name="componentName_" [(ngModel)]="componentName" #componentName_="ngModel" placeholder="Component Name">
          </mat-form-field>
  
          <mat-form-field class="header-form-full-width">
            <mat-select placeholder="Sub System/Component Type" name="comSubType" [(ngModel)]="comSubType">
              <mat-option [value]="type.Id" *ngFor="let type of _componentservice.componentTypeList">
                {{type.Title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
       
        </form>
      </mat-card>
      <mat-card class="panel_search mat-card">

        <div class="panel_sub_header">
          <span class="panel__header__title">Component Extra Details</span>
        </div>

        <form class="header-form">

          <mat-form-field class="header-form-full-width">
            <textarea rows="2" cols="50" matInput name="compart_note_" [(ngModel)]="compart_note" #compart_note_="ngModel"
              placeholder="Component Note"></textarea>
          </mat-form-field>

          <mat-form-field class="header-form-full-width">
            <input matInput name="smcs_code_" [(ngModel)]="smcs_code" #smcs_code_="ngModel" placeholder="SMCS Job Code">
          </mat-form-field>

          <mat-form-field class="header-form-full-width">
            <input matInput name="budget_life_" [(ngModel)]="budget_life" #budget_life_="ngModel" placeholder="Budget Life(Hours)"
              required>
          </mat-form-field>

           <!--model select-->
           <mat-form-field class="header-form-full-width">
            <mat-select placeholder="Model" name="moduleid_" [(ngModel)]="moduleid" #moduleid_="ngModel"  required>
              <mat-option [value]="model.Id" *ngFor="let model of _componentservice.availableModelList">
                {{model.Title}}
              </mat-option>
            </mat-select>
            <mat-error>Please select a Model</mat-error>
          </mat-form-field>


          <mat-form-field class="header-form-full-width">
            <mat-select placeholder="U/C Make" name="make_auto" [(ngModel)]="make_auto" required>
              <mat-option [value]="type.Id" *ngFor="let type of _componentservice.availableMakeList">
                {{type.Name}}
              </mat-option>
            </mat-select>
            <mat-error>Please select a U/C Make</mat-error>
          </mat-form-field>

          <mat-form-field class="header-form-full-width">
            <mat-select placeholder="Default Tool Used" name="tool_auto" [(ngModel)]="tool_auto"
              required>
              <mat-option [value]="type.ToolId" *ngFor="let type of _componentservice.measurementToolsList">
                {{type.ToolName}}
              </mat-option>
            </mat-select>
            <mat-error>Please select a Tool Used</mat-error>
          </mat-form-field>

          <div class="apply-module-container">
            <div>
              <a class="apply-module-container-add-button button button--primary"><i class="material-icons button__icon"
                  style="margin-right: 0px"></i><span class="button__text">Add</span></a>

            </div>
          <!-- <mat-form-field class="header-form-full-width">
            <mat-chip-list #chipList>
              <mat-chip *ngFor="let title of modelNameID" [selectable]="selectable"  >
                {{title}}
                <mat-icon >cancel</mat-icon>
              </mat-chip>
              <input placeholder="Apply Models..."  />
            </mat-chip-list>
          </mat-form-field> -->
         </div>     
        </form>

        <form class="header-form">
          <div class="flex-box-align">
          
            <div class="flex-column-shared flex-align-column-shared">
              <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text">
                  Add Component Image</span></a>
              <img style="width:100px; height:100px"  >
            </div>
          
         
            <div class="flex-column-shared flex-align-column-shared">
              <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text">
                  Add Testing Point Image</span></a>
              <img style="width:100px; height:100px"  >
            </div>
           
          </div> 
        </form>

        <div class="border-box-container">
          <div class="border-box">

            <mat-form-field class="mat-form-width-shared ">
              <input matInput name="track_compart_worn_calc_method_name_" [(ngModel)]="track_compart_worn_calc_method_name"
                #track_compart_worn_calc_method_name_="ngModel" placeholder="Method of Calculation" readonly>
            </mat-form-field>

            <mat-form-field class="mat-form-width-shared ">
              <input matInput name="modified_user_" [(ngModel)]="modified_user" #modified_user_="ngModel" placeholder="Modified User"
                readonly>
            </mat-form-field>

            <mat-form-field class="mat-form-width-shared ">
              <input matInput name="modified_date_short_" [(ngModel)]="modified_date_short" #modified_date_short_="ngModel"
                placeholder="Modified Date" readonly>
            </mat-form-field>

          </div>

          <a class="button button--primary" style="margin-top:10px;"><i class="material-icons button__icon"></i><span class="button__text" >
              Setup/Edit Percentage Worn Limits</span></a>
        </div>

      </mat-card>
    
  </div>
</div>